const BRIDGED_EVENTS = ["click", "mousedown"];

export function bridgeOutsideClicks(target: Window): () => void {
  const nativeAdd = document.addEventListener;
  const nativeRemove = document.removeEventListener;

  function add(
    type: string,
    listener: EventListenerOrEventListenerObject,
    options?: boolean | AddEventListenerOptions,
  ): void {
    nativeAdd.call(document, type, listener, options);

    if (BRIDGED_EVENTS.includes(type)) {
      target.document.addEventListener(type, listener, options);
    }
  }

  function remove(
    type: string,
    listener: EventListenerOrEventListenerObject,
    options?: boolean | EventListenerOptions,
  ): void {
    nativeRemove.call(document, type, listener, options);

    if (BRIDGED_EVENTS.includes(type)) {
      target.document.removeEventListener(type, listener, options);
    }
  }

  document.addEventListener = add as typeof document.addEventListener;
  document.removeEventListener = remove as typeof document.removeEventListener;

  return () => {
    document.addEventListener = nativeAdd;
    document.removeEventListener = nativeRemove;
  };
}
